import { AppLanguage } from '~/common/enums/enums';

const APP_LANGUAGES = [AppLanguage.UA, AppLanguage.EN] as const;

export { APP_LANGUAGES };
